import { render, staticRenderFns } from "./messages-table-filter.vue?vue&type=template&id=2b70872e&"
import script from "./messages-table-filter.vue?vue&type=script&lang=js&"
export * from "./messages-table-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports